module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/consumer-join-tick-8c51c1b8d26bb22a4ed37d6e0c6c053d.jpg";